<template>
  <div class="begin_create">
    <slot />
  </div>
</template>

<script>
export default {
  props: {},
};
</script>

<style lang="scss" scoped>
.begin_create {
  height: calc(100vh - 162px);
  display: flex;
  flex-direction: column;
  min-height: 480px;
  // justify-content: center;
  align-items: center;
  img {
    animation: fadeInUp 0.8s 1;
  }
}
</style>
